import { render, staticRenderFns } from "./HorizontalNavMenuGroup.vue?vue&type=template&id=c78fffdc&scoped=true&"
import script from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNavMenuGroup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HorizontalNavMenuGroup.vue?vue&type=style&index=1&id=c78fffdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78fffdc",
  null
  
)

export default component.exports